import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "buds_admin_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      localStorage.removeItem(TOKEN_KEY);
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export const TIERS = [
  {
    id: "bud",
    name: "The Bud",
    price: 1500,
    tagline: "Premium variety of farm-fresh stems.",
    features: [
      "Designer bouquet or arrangement",
      "Premium farm-fresh flowers",
      "Fresh seasonal flowers",
      "Thoughtfully curated every delivery",
      "Complimentary delivery",
    ],
    image:
      "https://images.pexels.com/photos/8582271/pexels-photo-8582271.jpeg",
    badge: null,
    cta: "Subscribe to The Bud",
  },
  {
    id: "bloom",
    name: "The Bloom",
    price: 2500,
    tagline: "A mix of local high-end farm-fresh stems.",
    features: [
      "Larger premium arrangement",
      "Mix of premium local flowers",
      "Unique floral design every delivery",
      "Complimentary delivery",
      "Priority customer support",
    ],
    image:
      "https://images.pexels.com/photos/931162/pexels-photo-931162.jpeg?auto=compress&cs=tinysrgb&w=1200",
    badge: null,
    cta: "Subscribe to The Bloom",
  },
  {
    id: "signature",
    name: "The Signature",
    price: 3500,
    tagline:
      "A composition of high-end farm-fresh local and imported stems from around the globe.",
    features: [
      "Luxury designer arrangement",
      "Premium local flowers",
      "Imported seasonal flowers",
      "Unique luxury floral compositions",
      "Complimentary delivery",
      "Priority customer support",
    ],
    image:
      "https://images.unsplash.com/photo-1487530811176-3780de880c2d?auto=format&fit=crop&w=1200&q=80",
    badge: "Imported Stems Included",
    cta: "Become a Signature Member",
  },
];

export const TIER_MAP = Object.fromEntries(TIERS.map((t) => [t.id, t]));
